//BB: DAshboard Reducer


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Student {

    //teacher: string;
    teacher_id: string;
    selectedcourselist: [];
    // course_id :string | null;
    // course_name :string | null;
}

interface Studentstate {
    students: Student[];
    //course_id :string;
    // course_name :string;
    // isLoading: boolean;
    // error: string | null;
}

const initialState: Studentstate = {
    students: []
    //course_id: "", // Initialize as empty string instead of null
    //course_name: "", // Initialize as empty string instead of null

};


const studentListsDashboardSlice = createSlice({
    name: "studentListDashboard",
    initialState,
    reducers: {


        setStudentList: (state: Studentstate, action: PayloadAction<Student[]>) => {
            state.students = action.payload;

            //console.log("act",action);


            // state.isLoading = false;
            // state.error = null;
        },
        // setPagination: (state: CourseState, action: PayloadAction<CourseState>) => {
        //     state.next = action.payload.next;
        //     state.previous = action.payload.previous;
        //     state.count = action.payload.count;
        //     state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
        //     state.isLoading = false;
        //     state.error = null;
        // },
        // setloading: (state: CourseState, action: PayloadAction<boolean>) => {
        //     state.isLoading = action.payload;
        //     state.error = null;
        // },
        // seterror: (state: CourseState, action: PayloadAction<string>) => {
        //     state.error = action.payload;
        //     state.isLoading = false;
        // },
        resetStudentList: () => {
            return initialState;
        },
    },
});

export const {
    setStudentList,
    // setloading,
    // seterror,
    // setPagination,
    resetStudentList
} = studentListsDashboardSlice.actions;

export default studentListsDashboardSlice.reducer;
